import React from 'react';
import { Button } from './ui/Button';
import { Gift, GlassWater, Leaf, Cookie, Brain } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: <GlassWater className="w-8 h-8 text-emerald-600" data-id="element-25" />,
    title: 'Smoothies Cero Inflamación',
    desc: 'Opciones rápidas para días sin tiempo — listos en 5 minutos',
    image: 'https://cdn.magicpatterns.com/uploads/tFbhUwPWnvk2hn8osMi756/ChatGPT_Image_6_feb_2026,_19_59_35.png'
  }, {
    icon: <Leaf className="w-8 h-8 text-emerald-600" data-id="element-26" />,
    title: 'Fermentados Fácil y Casero',
    desc: 'Tu microbiota feliz = menos hinchazón sin suplementos caros',
    image: 'https://cdn.magicpatterns.com/uploads/egNKqX6TZLbkq2avT1nqJn/ChatGPT_Image_6_feb_2026,_20_03_41.png'
  }, {
    icon: <CoffeeIcon className="w-8 h-8 text-emerald-600" data-id="element-27" />,
    title: 'Ritual de Infusiones',
    desc: 'Qué tomar, cuándo y por qué — para potenciar el proceso',
    image: 'https://cdn.magicpatterns.com/uploads/3fppLjbsRgdTyBrAFswtBE/ChatGPT_Image_6_feb_2026,_20_00_27.png'
  }, {
    icon: <Cookie className="w-8 h-8 text-emerald-600" data-id="element-28" />,
    title: 'Postres Fit sin Culpa',
    desc: 'Tartas, dulces y antojos que no inflaman — sí, existen',
    image: 'https://cdn.magicpatterns.com/uploads/uittQkQAN1CkxrGM7tg6Zv/ChatGPT_Image_6_feb_2026,_20_55_57.png'
  }, {
    icon: <Brain className="w-8 h-8 text-emerald-600" data-id="element-29" />,
    title: 'Guía Antiantojos Inteligentes',
    desc: 'Qué comer entre comidas para no volver al azúcar',
    image: 'https://cdn.magicpatterns.com/uploads/euxScFUFMkRdhJ9umqbLkr/ChatGPT_Image_6_feb_2026,_20_57_29.png'
  }];
  return <section className="py-20 bg-emerald-900 text-white" data-id="element-30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="max-w-6xl mx-auto" data-id="element-32">
          <div className="text-center mb-16" data-id="element-33">
            <div className="inline-flex items-center justify-center bg-emerald-800 px-4 py-1 rounded-full mb-4 border border-emerald-700" data-id="element-34">
              <Gift className="w-4 h-4 mr-2 text-emerald-300" data-id="element-35" />
              <span className="text-sm font-bold text-emerald-100 uppercase tracking-wider" data-id="element-36">
                Regalo Exclusivo
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-37">
              Además te llevás GRATIS estos bonos
            </h2>
            <p className="text-xl text-emerald-200 font-serif italic" data-id="element-38">
              Diseñados para que no tengas excusa de no empezar hoy.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-39">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-xl hover:transform hover:-translate-y-1 transition-all duration-300" data-id="element-40">
                {bonus.image && <div className="h-40 overflow-hidden" data-id="element-41">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-42" />
                  </div>}
                <div className="p-6" data-id="element-43">
                  <div className="mb-4 bg-emerald-50 w-12 h-12 rounded-full flex items-center justify-center" data-id="element-44">
                    {bonus.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-emerald-900" data-id="element-45">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-46">
                    {bonus.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="text-center bg-emerald-800/50 rounded-2xl p-8 max-w-3xl mx-auto border border-emerald-700" data-id="element-47">
            <p className="text-2xl font-bold mb-8" data-id="element-48">
              Todo incluido. Sin costo extra. Solo por empezar hoy.
            </p>
            <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" data-id="element-49">
              <Button variant="secondary" size="xl" withArrow className="w-full sm:w-auto text-emerald-900 font-extrabold" data-id="element-50">
                QUIERO EMPEZAR EL RETO AHORA
              </Button>
            </a>
            <div className="mt-4" data-id="element-51">
              <p className="text-xl md:text-2xl font-bold text-white" data-id="element-52">
                $14,997 con el 50% desc
              </p>
              <p className="text-sm font-medium text-emerald-300" data-id="element-53">
                Pago único — sin suscripciones
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
// Helper component for the Coffee icon since we need to rename it to avoid conflict if imported as Coffee
function CoffeeIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-54">
      <path d="M17 8h1a4 4 0 1 1 0 8h-1" data-id="element-55" />
      <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" data-id="element-56" />
      <line x1="6" x2="6" y1="2" y2="4" data-id="element-57" />
      <line x1="10" x2="10" y1="2" y2="4" data-id="element-58" />
      <line x1="14" x2="14" y1="2" y2="4" data-id="element-59" />
    </svg>;
}